import { useEnv } from '@/hooks/env'
import { isNil, isObject } from 'lodash-es'
export function isValidDate(stringDate) {
  return !isNaN(Date.parse(stringDate))
}
// 替换一个对象中的某些值为目标值
export const replaceValueByObj = (obj: Recordable, sourceValue = null, targetValue = undefined) => {
  if (isObject(obj)) {
    for (let key in obj) {
      if (obj[key] === sourceValue) {
        obj[key] = targetValue
      }
      if (isObject(obj[key])) {
        replaceValueByObj(obj[key], sourceValue, targetValue)
      }
      if (Array.isArray(obj[key])) {
        obj[key].forEach(item => {
          if (isObject(item)) {
            replaceValueByObj(item)
          }
        })
      }
    }
  }
}
// 递归查找数组
export const arrFind = (arr: any, field: string, value: any, children = 'children'): any => {
  for (let key in arr) {
    if (Object(arr[key])[field] == value) {
      return arr[key]
    }
    if (Object(arr[key])[children]) {
      let find = arrFind(Object(arr[key])[children], field, value, children)
      if (find) {
        return find
      }
    }
  }
  return null
}


// 保留n位小数，不做四舍五入
export function getNumberResult(a, n?: number) {
  if (!a) {
    return '0.00'
  }
  // eslint-disable-next-line no-nested-ternary
  n = isNil(n) ? 2 : n < 0 ? 2 : n
  let num = n > 0 ? Math.pow(10, n) : 0
  // 保留两位小数，不做四五入
  return (Math.floor(a * num) / num).toFixed(n)
}

// 处理成以K为单位
type MoneyUnitType = '元' | 'K' | '万'
export const handLeMoneyFn = (v: string | number, unit?: MoneyUnitType) => {
  if (!v) {
    return v
  }
  if (isNaN(parseInt(`${v}`))) {
    return v
  }
  const TypeMap = {
    K: 1000,
    元: 1,
    万: 10000,
  }
  // 默认
  unit = unit ?? 'K'
  let divideNum = TypeMap[unit] ?? 1000

  let res: any = parseInt(`${v}`)

  // if (res > 10000) {
  //   divideNum = 10000
  //   unit = '万'
  // } else if (res > 1000) {
  //   divideNum = 1000
  //   unit = 'K'
  // } else {
  //   divideNum = 1
  //   unit = '元'
  // }

  // res = `${currency(res, { precision: 2 }).divide(divideNum).value}${unit}`//四舍五入
  // res = `${(res / divideNum).toPrecision(2)}${unit}`//也会四舍五入
  res = `${getNumberResult(res / divideNum)}${unit}`

  return res
}
// 对象数组去重
export function uniqueFunc(arr: any[], uniId: string) {
  const res = new Map()
  return arr.filter(item => !res.has(item[uniId]) && res.set(item[uniId], 1))
}

export const getFileFullUrl = (url: string) => `${useEnv.appFileUrl}/${url}`
export function isChinese(str) {
  let filter = /[\u4E00-\u9FA5\uF900-\uFA2D]{1,}/
  if (filter.test(str)) {
    // console.log('存在汉字')
    return true
  } else {
    // console.log('不存在汉字')
    return false
  }
}

export function isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag
}

export function getLabelByOptions(
  value,
  options: any = [],
  labelField = 'label',
  valueFidld = 'value'
): string {
  if (!Array.isArray(options)) {
    return '--'
  }
  const findItem = options.find(item => item[valueFidld] == value)
  if (findItem) {
    return findItem[labelField]
  }
  return '--'
}
export function getItemByOptions(
  value,
  options: any = [],
  labelField = 'label',
  valueFidld = 'value'
) {
  if (!Array.isArray(options)) {
    return null
  }
  const findItem = options.find(item => item[valueFidld] == value)
  if (findItem) {
    return {
      label: findItem[labelField],
      value: findItem[valueFidld],
      color: findItem.color,
    }
  }
  return null
}
export function getAgeByBirthDay(birthday: string): number | string {
  if (!birthday || birthday === '0000-00-00') {
    return '--'
  }
  let today = new Date()
  let birthdate = new Date(birthday)
  let age = today.getFullYear() - birthdate.getFullYear()
  if (
    (today < birthdate || today.getMonth() < birthdate.getMonth())
    && age - 1 >= 0
  ) {
    age-- // 如果今天的月份小于生日的月份或者今天的日期小于生日的日期，则年龄需要减1
  }
  return age
}

export function removeEmptyAndUndefined(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // 创建一个副本以避免修改原始对象
  const copy = Array.isArray(obj) ? [...obj] : { ...obj }

  // 遍历对象或数组的每一个属性或元素
  for (const key in copy) {
    // 递归调用自身处理嵌套对象和数组
    copy[key] = removeEmptyAndUndefined(copy[key])

    // 如果值是空对象或 undefined，删除该属性或元素
    if (isEmptyObject(copy[key]) || copy[key] === undefined) {
      if (Array.isArray(copy)) {
        copy.splice(key, 1)
      } else {
        delete copy[key]
      }
    }
  }

  return copy
}

export function isEmptyObject(obj) {
  return (
    obj
    && typeof obj === 'object'
    && !Array.isArray(obj)
    && Object.keys(obj).length === 0
  )
}
